/**
 * kp-cart-checkout — marks the CTA once checkout has been asked for.
 *
 * Submitting the cart form is a full navigation to Shopify's checkout, and on
 * a slow connection that leaves the button looking untouched for a second or
 * two — long enough for a shopper to press it again. The canvas answers that
 * with a "REDIRECTING" label and the loader bars.
 *
 * The other busy state, "UPDATING", needs nothing here: Dawn already puts
 * `.cart__items--disabled` on the items container while a cart request is in
 * flight, and CSS reads it. This element exists only for the one transition
 * the platform gives no signal for.
 *
 * It holds no cart state — only "this form has been submitted", which is a
 * fact about the page, not about the cart.
 */
class KpCartCheckout extends HTMLElement {
  connectedCallback() {
    const button = this.querySelector('.kp-cart__checkout');
    const form = button?.form;
    if (!form) return;

    form.addEventListener('submit', () => {
      // Not `disabled`: a disabled submit button is not sent with the form,
      // and this one carries name="checkout".
      this.dataset.state = 'redirecting';
    });

    // Coming back via the bfcache (the shopper pressed Back) restores the DOM
    // as it was, mid-redirect. Without this the button says REDIRECTING for
    // a navigation that already finished and came back.
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) delete this.dataset.state;
    });
  }
}

if (!customElements.get('kp-cart-checkout')) customElements.define('kp-cart-checkout', KpCartCheckout);
